<router-outlet *ngIf="nonIE; else elseIE"></router-outlet>
<ng-template #elseIE>
  <aside class="center blank blank-{{slug}}">
    <img src="{{imagesOthers}}logo.svg" alt="logo">
    <p [innerText]="theo('ie_not_supported')"></p>
  </aside>
</ng-template>
